import React, { useState, useRef, useEffect } from 'react';
import { getGlobalDiscount } from '../../services/cashFlow/cashFlow'
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { cedimi } from '../../constant/globalConstantsTypeClients';
import moment from 'moment';
import * as XLSX from 'xlsx';



export const useReportDiscounts = () => {

  // ? REPORT
  const [reportDiscounts, setReportDiscounts] = useState([]);
  const [chartData, setChartData] = useState({});
  const [chartOptions1, setChartOptions] = useState({});
  const [globalDevolutionFilter, setGlobalDevolutionFilter] = useState(null);
  const chartDevolutionRef = useRef(null);
  const [createSweet] = useSweetAlert();
  const [loadingCancell, setLoadingCancell] = useState(false);





  const [filters, setFilters] = useState({
    dateStart: moment().format("YYYY-MM") + "-01",
    dateEnd: moment().endOf('month').format("YYYY-MM-DD"),
  });

  useEffect(() => {
    GetReportDiscounts()
  }, [])


  const GetReportDiscounts = async (alterDateStart = null, alterDateEnd = null) => {
    try {
      setLoadingCancell(true);

      const detailDiscount = await getGlobalDiscount(
        alterDateStart ?? filters.dateStart,
        alterDateEnd ?? filters.dateEnd
      );

      if (detailDiscount.code === 200) {

        const data = detailDiscount.data || [];
        setReportDiscounts(data);

        let grouped = {};

        data.forEach(item => {

          const discountName =
            item.name_Preloaded_discount?.trim()
              ? item.name_Preloaded_discount
              : item.nameCommont?.trim()
                ? item.nameCommont
                : "Descuento sin nombre";

          const key = discountName.toLowerCase().trim();

          if (!grouped[key]) {
            grouped[key] = {
              name: discountName,
              total: 0,
              count: 0
            };
          }

          grouped[key].total += item.amountDiscount || 0;
          grouped[key].count += 1;
        });

        const groupedData = Object.values(grouped)
          .filter(item => item.total > 0)
          .sort((a, b) => b.total - a.total);

        const colors = [
          '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC',
          '#EC407A', '#FF7043', '#26C6DA', '#D4E157',
          '#8D6E63', '#26A69A', '#7E57C2', '#FFCA28', '#90CAF9'
        ];

        const backgroundColors = groupedData.map(
          (_, i) => colors[i % colors.length]
        );

        const chartData = {
          labels: groupedData.map(item => item.name),
          datasets: [
            {
              label: 'Total bonificado ($)',
              data: groupedData.map(item => item.total),
              backgroundColor: backgroundColors
            },
            {
              label: 'Veces aplicadas',
              data: groupedData.map(item => item.count),
              backgroundColor: backgroundColors
            }
          ]
        };

        const chartOptions = {
          responsive: true,
          plugins: {
            legend: {
              position: 'top'
            },
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  const label = ctx.dataset.label;
                  const value = ctx.raw;
                  return `${label}: ${label === 'Total bonificado ($)'
                    ? '$' + value.toFixed(2)
                    : value
                    }`;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Cantidad'
              }
            },
            x: {
              ticks: {
                display: false
              },
              grid: {
                display: false
              }
            }
          }
        };

        setChartData(chartData);
        setChartOptions(chartOptions);

      } else {
        setChartData({});
        setChartOptions({});
      }

    } catch (error) {
      createSweet(
        "error",
        "error",
        "Opss..",
        "Error al obtener el reporte de descuento"
      );
    } finally {
      setLoadingCancell(false);
    }
  };


  function exportToExcelDiscounts(nimDataExcel) {
    let _Report = [];
    let _array = reportDiscounts;

    _array.forEach((_find, key) => {

      let reportObject = {
        "Nim": _find?.nim,
        "Sucursal": _find?.name_branches,
        "Paciente": _find?.name,
        "Edad": _find?.age,
        "Descuento aplicado": _find?.name_Preloaded_discount,
        "Porcentaje de descuento": _find?.percentagePreloaded_discount,
        "Total de descuento aplicado": _find?.amountDiscount,
        "Total Cobrado": _find?.amount,
        "Metodo de pago": _find?.nameMethod,
        "Fecha de aplicación": _find?.fech
      };
      _Report.push(reportObject);
    });

    const worksheet = XLSX.utils.json_to_sheet(_Report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = 'Repote Descuentos.xlsx';

    if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  const handleReport = () => {
    GetReportDiscounts(filters.dateStart, filters.dateEnd);
  };





  const [viewCard, setViewCard] = useState(true)

  const handleViewCard = () => {
    setViewCard(!viewCard)
  }

  const handleCloseCard = () => {
    setViewCard(false)
  }







  return {
    setFilters, filters, loadingCancell,
    reportDiscounts, chartData, chartOptions1, globalDevolutionFilter,
    chartDevolutionRef, handleReport, exportToExcelDiscounts,
    setGlobalDevolutionFilter,
    handleViewCard, handleCloseCard, viewCard,


  }
}

